import { Box, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

type DrawerHeaderProps = {
  title: string | React.ReactNode;
  whithoutDivider?: boolean;
  onClose?: () => void;
};

const useStyles = makeStyles(({ palette, spacing }) => ({
  root: ({ whithoutDivider }: { whithoutDivider?: boolean }) => ({
    margin: 0,
    padding: spacing(2),
    display: 'flex',
    alignItems: 'center',
    borderBottom: whithoutDivider ? 'none' : `1px solid ${palette.divider}`,
  }),
  title: {
    flexGrow: 1,
    paddingRight: spacing(6),
    fontWeight: 500,
  },
  closeButton: {
    color: palette.text.disabled,
    position: 'absolute',
    right: spacing(1),
    top: spacing(1),
  },
}));

export default function DrawerHeader({
  title,
  whithoutDivider = false,
  onClose,
}: DrawerHeaderProps) {
  const classes = useStyles({ whithoutDivider });

  return (
    <Box className={classes.root}>
      <Typography
        variant="body1"
        component="div"
        className={classes.title}
        noWrap
      >
        {title}
      </Typography>

      {onClose ? (
        <IconButton
          size="small"
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </Box>
  );
}
